export default function InstagramLogo(props: React.ComponentProps<"svg">) {
    return (
        <svg
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.7" clipPath="url(#clip0_1173_3302)">
                <path
                    d="M15.2593 3.68005C14.6088 3.68005 14.0815 4.20744 14.0815 4.8579C14.0815 5.50835 14.6088 6.03575 15.2593 6.03575C15.9098 6.03575 16.4372 5.50835 16.4372 4.8579C16.4372 4.20744 15.9098 3.68005 15.2593 3.68005ZM10.0322 5.19191C7.30735 5.19191 5.09229 7.40697 5.09229 10.1318C5.09229 12.8567 7.30735 15.0718 10.0322 15.0718C12.7571 15.0718 14.9722 12.8567 14.9722 10.1318C14.9722 7.40697 12.7571 5.19191 10.0322 5.19191ZM10.0322 13.2904C8.28597 13.2904 6.86786 11.8723 6.86786 10.126C6.86786 8.37972 8.28597 6.96162 10.0322 6.96162C11.7785 6.96162 13.1966 8.37972 13.1966 10.126C13.1966 11.8723 11.7785 13.2904 10.0322 13.2904ZM20 6.02403C20 2.69558 17.3044 0 13.976 0H6.02403C2.69558 0 0 2.69558 0 6.02403V13.976C0 17.3044 2.69558 20 6.02403 20H13.976C17.3044 20 20 17.3044 20 13.976V6.02403ZM18.1131 13.976C18.1131 16.2614 16.2614 18.1131 13.976 18.1131H6.02403C3.73865 18.1131 1.8869 16.2614 1.8869 13.976V6.02403C1.8869 3.73865 3.73865 1.8869 6.02403 1.8869H13.976C16.2614 1.8869 18.1131 3.73865 18.1131 6.02403V13.976Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1173_3302">
                    <rect width="20" height="20" fill="currentColor" />
                </clipPath>
            </defs>
        </svg>
    )
}
